import { useEffect, useState } from "react";
import { PlusSmallIcon } from "@heroicons/react/24/outline";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { useCollectionOptions } from "../../data/useCollectionOptions";
import { ICollectionOption } from "../../models/CollectionOption";
import CollectionOptionTable from "../../components/collectionOptions/CollectionOptionTable";
import CollectionOptionModal from "../../components/collectionOptions/CollectionOptionModal";

export default function CollectionOptions() {
  const { setInfo } = usePageNameContext();
  const { collectionOptions: allOptions } = useCollectionOptions();
  const [options, setOptions] = useState<ICollectionOption[] | undefined>(undefined);
  const [selected, setSelected] = useState<ICollectionOption | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Collection Options",
      desc: "Manage collection options available to customers",
    });
  }, []);

  useEffect(() => {
    if (!allOptions.isLoading && allOptions.data) {
      setOptions(allOptions.data.data);
      setIsLoading(false);
    }
  }, [allOptions.isLoading, allOptions.data]);

  const handleSelect = (option: ICollectionOption) => {
    setSelected(option);
    setModalOpen(true);
  };

  const handleAdd = () => {
    setSelected(undefined);
    setModalOpen(true);
  };

  if (allOptions.isLoading || isLoading) {
    return (
      <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
        <LoadingWheel />
      </div>
    );
  }

  return (
    <>
      <CollectionOptionModal open={modalOpen} setOpen={setModalOpen} collectionOption={selected} />
      <div className="mt-4 flex justify-between">
        <button
          className="bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
          onClick={handleAdd}
        >
          <PlusSmallIcon className="h-5 w-5 mr-2" />
          Add Collection Option
        </button>
      </div>
      <CollectionOptionTable
        collectionOptions={options ?? []}
        setCollectionOption={handleSelect}
      />
    </>
  );
}
